import { Get, Post } from "./apiUtils";
import { PagedModel, LineHandling, SVLModel } from "../models";

const getLineHandlingListAsync = async (
  status: string,
  salesOrg: string,
  pageNo: number = 1,
  pageSize: number = 5,
  keyword: string = ""
): Promise<PagedModel<LineHandling>> => {
  const response = await Get(
    `/api/linehandling/${status}?salesOrg=${salesOrg}&pageNo=${pageNo}&pageSize=${pageSize}&keyword=${keyword}`
  );
  const result = await response.json();
  return result;
};

const getLineHandlingAsync = async (
  lineHandlingNo: string,
  cacheFirst: boolean = false
): Promise<LineHandling> => {
  const response = await Get(`/api/linehandling/${lineHandlingNo}`, cacheFirst);
  const result = await response.json();
  return result;
};

const updateShipVaporLineAsync = async (
  lineHandlingNo: string,
  nominations: SVLModel[],
  offlineUpdate: (() => void) | undefined = undefined
): Promise<Response> => {
  const response = await Post(
    `/api/linehandling/${lineHandlingNo}/update-svl`,
    JSON.stringify(nominations)
  );

  if (response.status === 399) {
    if (offlineUpdate) {
      offlineUpdate();
    }
  }

  return response;
};

const generateEtaAsync = async (lineHandlingNo: string): Promise<LineHandling> => {
  const response = await Get(`/api/linehandling/${lineHandlingNo}/eta`);
  const result = await response.json();
  return result;
};

export const LineHandlingApi = {
  getLineHandlingListAsync,
  getLineHandlingAsync,
  updateShipVaporLineAsync,
  generateEtaAsync,
};
